import { VoidFunctionComponent } from 'react';
import { StyledPlaceholder } from './Placeholder.styled';
import { PlaceholderProps } from './types';

export const Placeholder: VoidFunctionComponent<PlaceholderProps> = props => {
  const { width = 100 } = props;

  return <StyledPlaceholder $width={width}>{'\u200c'}</StyledPlaceholder>;
};
